import importer from '@boschebike/ebds-js/dist-esm/helpers/web-generic/feedback.import.prod.js';

importer();
